const PASSWORD_BUTTON_ADORNIMENT_ID = 'show-password-btn-id';
const PASSWORD_INPUT_ID = 'password-input-id';
const FORGOT_PASSWORD_LINK_ID = 'forgot-password-link-id';

export {
  PASSWORD_BUTTON_ADORNIMENT_ID,
  PASSWORD_INPUT_ID,
  FORGOT_PASSWORD_LINK_ID
};
